/* BaseJnibAdapter.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const LogAdapter = require("./BaseLogger");

//The below require statement will load the default JNIB Adapter, this will need to be monkeyPatched...
const webJnibEngine = require("@gluenetworks/web_jnib_engine"); //jshint ignore:line
//At this point in the execution the webJnibEngine is not yet initialized...
//it will turn the event loop before it initializes itself

class BaseJnibAdapter extends EventEmitter {
    constructor(userSession, logger) {
        super();
        this._userSession = userSession;
        this._nibMgr = webJnibEngine.nibMgr;
        this._nibAdapter = webJnibEngine.nibAdapter;

        this.log = new LogAdapter(logger);
    }
    /**************************************************/
    /* START BASE JNIB ADAPTER METHODS                */
    /**************************************************/
    get nibApiService() {
        return this.getNibApiService();
    }
    getNibApiService() {
        return this._nibApiService;
    }
    /**
     * Called when a continuation is started.
     */
    startContinuation(continuation, startObj) {
        this.emit("ContinuationStarted", {
            continuation: continuation,
            startObj: startObj,
        });
    }
    /**
     * Called when a continuation is finished.
     */
    finishContinuation(continuation, finishObj) {
        this.emit("ContinuationFinished", {
            continuation: continuation,
            finishObj: finishObj,
        });
    }
    /**************************************************/
    /* END BASE JNIB ADAPTER METHODS                  */
    /**************************************************/

    /**************************************************/
    /* ADAPTER PUBLIC METHODS                         */
    /**************************************************/

    getUserSession() {
        return this._userSession;
    }

    get userSession() {
        return this.getUserSession();
    }
}
module.exports = BaseJnibAdapter;
